/** Product-facing label for a rule; persisted IDs remain stable for history and integrations. */
export function displayRuleId(ruleId: string): string {
  return ruleId.replace(/^ASSURE-/u, "PROV-");
}
